import '../landing/index.scss';
import QRCode from 'qrcode';

document.documentElement.classList.add('landing-ready');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vietqr-payload]').forEach(canvas => {
    QRCode.toCanvas(canvas, canvas.dataset.vietqrPayload, {
      width: 280,
      margin: 2,
      errorCorrectionLevel: 'M',
    });
  });

  const header = document.querySelector('[data-landing-header]');
  const updateHeader = () =>
    header?.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  menuToggle?.addEventListener('click', () => {
    const isOpen = mobileMenu?.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
  });
  const closeMobileMenu = () => {
    mobileMenu?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  };
  mobileMenu?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileMenu);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMobileMenu();
  });

  const revealObserver = new IntersectionObserver(
    entries =>
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      }),
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  document
    .querySelectorAll('.reveal')
    .forEach(element => revealObserver.observe(element));

  const parallax = document.querySelector('[data-parallax] .visual-frame');
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  if (
    parallax &&
    !reduceMotion &&
    window.matchMedia('(pointer: fine)').matches
  ) {
    parallax.parentElement.addEventListener('pointermove', event => {
      const bounds = parallax.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      parallax.style.transform = `rotateY(${x * 4}deg) rotateX(${-y * 4}deg)`;
    });
    parallax.parentElement.addEventListener('pointerleave', () => {
      parallax.style.transform = '';
    });
  }
});
